// Single source for every localStorage / sessionStorage key the app uses.
//
// Web-storage keys are stringly-typed: a typo in one of the (e.g. 8)
// "strongbot_token" call sites silently logs the user out instead of failing
// loudly. Centralising them means a typo is a compile-time missing-property, the
// set of keys is auditable in one place, and renaming a key is one edit. Never
// re-type a raw storage-key string elsewhere — import STORAGE_KEYS from here.
export const STORAGE_KEYS = {
  // Auth JWT (read on every authed request; a typo here = silent logout).
  TOKEN: "strongbot_token",
  // Voice-chat selected voice preference.
  VOICE: "sb-voice",
  // Pending document handed from a public page into the dashboard chat.
  PENDING_DOC_NAME: "sb-pending-doc-name",
  PENDING_DOC_ID: "sb-pending-doc-id",
  // Use-case kit prompt/system-prompt carried into the dashboard.
  KIT_PENDING_PROMPT: "sb-kit-pending-prompt",
  KIT_SYSTEM_PROMPT: "sb-kit-system-prompt",
  // One-shot UI dismissals / consent flags.
  EXIT_INTENT_SEEN: "sb_exit_intent_seen",
  COOKIE_CONSENT: "sb_cookie_consent",
  STICKY_DISMISSED: "sb_sticky_dismissed",
  PWA_DISMISSED: "sb_pwa_dismissed",
  PWA_INSTALLED: "sb_pwa_installed",
  // Selected UI language (read by the i18next language detector).
  LANGUAGE: "strongbot_language",
  // Light/dark theme preference.
  THEME: "strongbot_theme",
  // Onboarding tutorial completion + the kit the user picked during it.
  ONBOARDING_DONE: "strongbot_onboarding_done",
  PREFERRED_KIT: "strongbot_preferred_kit",
  // AI-data-usage consent gate (App Review 5.1.1).
  AI_CONSENT: "strongbot_ai_consent",
  // "You're near your limit" nudge — dismissed-until timestamp.
  USAGE_NUDGE_DISMISSED_UNTIL: "strongbot_usage_nudge_dismissed_until",
  // Cached live model count (so the badge doesn't flash on cold load).
  MODEL_COUNT_CACHE: "strongbot_model_count_v1",
  // Dashboard resizable-pane widths.
  RAIL_WIDTH: "sb_rail_w",
  SIDEBAR_WIDTH: "sb_sidebar_w",
};
